export default __webpack_public_path__ + "fonts/Nunito-Bold.3d87361b.woff2";